export const formatPhoneNumber = (value: string): string => {
  const cleaned = value.replace(/\D/g, "");

  let withDDI = cleaned;
  if (!withDDI.startsWith("55")) {
    withDDI = "55" + withDDI;
  }

  const match = withDDI.substring(0, 13);

  if (match.length <= 2) {
    return match.length > 0 ? `+${match}` : "";
  } else if (match.length <= 4) {
    return `+${match.substring(0, 2)} (${match.substring(2)}`;
  } else if (match.length <= 9) {
    return `+${match.substring(0, 2)} (${match.substring(2, 4)}) ${match.substring(4)}`;
  } else {
    return `+${match.substring(0, 2)} (${match.substring(2, 4)}) ${match.substring(4, 9)}-${match.substring(9)}`;
  }
};

export const getPhoneNumberDigits = (value: string): string => {
  return value.replace(/\D/g, "");
};
